export const DEV_ZONE_MENU = 'avada-faqs-dev-zone-menu';
export const DRAFT_MESSAGE_CHAT = 'avada-faq-draft-message-chat';
export const SEND_VIA_EMAIL_KEY = 'avada-chatty/send-via-email';
export const INBOX_CONVO_ID = 'avada-chatty/convo-id';
export const INBOX_CONVO_MESSAGE_ID = 'avada-chatty/message-id';
export const LOGIN_BROWSER_TOKEN = 'avada-chatty/login-browser-token';
export const LOGIN_TIMESTAMP = 'avada-chatty/login-timestamp';
export const LOGIN_IS_PENDING = 'avada-chatty/login-is-pending';

export const SESSION_SHOPIFY_KEY = '_shopify_y';
export const SESSION_SHOPIFY_STORAGE_KEY = 'avada-chatty/session-shopify-storage';

export const IS_FIRST_SEND_MESSAGE = 'avada-chatty/is-first-send-message';
export const CLARITY_SESSION_ID = 'clarity-session-id';

export function getStorageData(key, blank = {}) {
  try {
    return JSON.parse(localStorage.getItem(key)) || blank;
  } catch (e) {
    console.log('Cannot get storage data', key);
    return blank;
  }
}

export function setStorageData(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    console.log('Cannot set storage data', key, value);
  }
}

export function removeStorageData(key) {
  try {
    localStorage.removeItem(key);
  } catch (e) {
    console.log('Cannot remove storage data', key);
  }
}

export function getAppHost() {
  const isProduction = process.env.NODE_ENV === 'production';
  if (isProduction) {
    return new URLSearchParams(location.search).get('host');
  }

  const localStorageHost = localStorage.getItem('avada-dev-host');
  const host = new URLSearchParams(location.search).get('host') || localStorageHost;
  localStorage.setItem('avada-dev-host', host);

  return host;
}

// Session storage
export function getSessionStorageData(key, blank = {}) {
  try {
    return JSON.parse(sessionStorage.getItem(key)) || blank;
  } catch (e) {
    console.log('get session storage error', key, e);
    return blank;
  }
}

export function setSessionStorageData(key, value) {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    console.log('set session storage error', key, value, e);
  }
}

export function removeSessionStorageData(key) {
  try {
    sessionStorage.removeItem(key);
  } catch (e) {
    console.log('remove session storage error', key, e);
  }
}
